export default "__VITE_ASSET__IFjVUDo3__"